import { ProductVideo } from 'components/ProductVideo';
import { ProductScreenshot } from 'components/ProductScreenshot';
import * as React from 'react';
export default {
  ProductVideo,
  ProductScreenshot,
  React
};